import Stat from "./Stat";

/** Telemetry tiles plus gate state — shown on the monitoring views only. */
export const VitalsBar = ({ m }) => {
  const met = m?.metrics;
  const remaining = met?.control_types_remaining || [];

  return (
    <>
      <div className="grid grid-cols-2 gap-px bg-[var(--line)] sm:grid-cols-3 lg:grid-cols-6">
        <Stat
          testid="admin-confidence-score"
          k="Predictive C"
          v={`${met?.predictive_confidence ?? 0}%`}
          sub={`target ${met?.target_confidence ?? 99.73}%`}
        />
        <Stat k="Honesty signal" v={Math.round(met?.honesty_signal ?? 0)} sub={met?.honesty_trend} />
        <Stat
          k="Control items"
          v={`${met?.n_control_items ?? 0}/14`}
          sub={`pass ${met?.control_pass_rate ?? 0}%`}
        />
        <Stat
          k="Types used"
          v={`${met?.control_types_used?.length ?? 0}/7`}
          sub={
            remaining.slice(0, 2).join(", ") +
              (remaining.length > 2 ? ` +${remaining.length - 2} more` : "") || "all exercised"
          }
        />
        <Stat
          k="Stability S"
          v={met?.stability_term ?? 0}
          sub={`σ ${met?.authenticity_sd ?? 0} · Δ ${met?.mean_deception_delta ?? 0}`}
        />
        <Stat
          k="Coverage"
          v={`${m?.coverage?.filled ?? 0}/${m?.coverage?.total ?? 46}`}
          sub={`phase ${m?.phase ?? "P0"} · ${m?.turn_count ?? 0} turns · ${m?.coverage?.facets ?? 0} facets`}
        />
      </div>

      <div className="mt-4 flex flex-wrap items-center gap-3 border border-[var(--line)] px-4 py-3">
        <span className="label">Gate</span>
        <span className="font-data text-[11px] text-zinc-100">{met?.gate_open ? "OPEN" : "SHUT"}</span>
        {met &&
          Object.entries(met.gate_requirements).map(([k, v]) => (
            <span key={k} className="font-data text-[10px] text-zinc-500">
              {k}: {v.have}/{v.need}
            </span>
          ))}
      </div>
    </>
  );
};

export default VitalsBar;
